import { MouseEvent } from "react";
import { baseRESTUrl, isImageEmbeddable, retrieveEncFile } from "lib/utils";
import { Asset, DisplayTypes } from "lib/types";
import { getTypeofAsset } from "../../../utils";

export const openFile = async (e: MouseEvent, pack: any, asset: Asset<any>) => {
  e.stopPropagation();

  let url = `${baseRESTUrl()}/v1/packs/${pack.id}/files/${asset.id}/${asset.data.filename}`;

  if (pack.is_encrypted) {
      url = await retrieveEncFile(pack.id, asset.id, asset.data.content_type, pack.key);
  }
  else if (asset.data.url) {
      url = `${baseRESTUrl()}/v1/packs/${pack.id}/files/${asset.data.url}`; // backwards compatibility
  }

  window.open(url, '_blank');
}

export const isAbleToBeEmbedded = (asset: Asset<any>) => {
  const displayType = getTypeofAsset(asset);

  if (displayType === DisplayTypes.IMAGE) {
    return isImageEmbeddable(asset.data.content_type);
  }

  return displayType === DisplayTypes.VIDEO || displayType === DisplayTypes.OEMBED;
};
